var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-trend-chart"},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 320 70"}},[_c('polyline',{attrs:{"points":_vm.points,"fill":"none","stroke":_vm.color,"stroke-width":"2"}}),_c('circle',{attrs:{"cx":_vm.lastPointX,"cy":_vm.lastPointY,"r":"3","fill":_vm.color}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }